export default function VideoPlayerIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
        stroke="#DD5A19"
      />
      <path
        d="M7.125 8.39985V9.60015C7.125 10.7396 7.125 11.3093 7.46682 11.5397C7.80862 11.7699 8.2761 11.5151 9.21112 11.0056L10.3123 10.4054C11.4374 9.79215 12 9.48555 12 9C12 8.51445 11.4374 8.20785 10.3123 7.59465L9.21112 6.99446C8.2761 6.48488 7.80862 6.23009 7.46682 6.46037C7.125 6.69065 7.125 7.26038 7.125 8.39985Z"
        fill="#DD5A19"
      />
    </svg>
  );
}
